import { createContext, useContext } from 'react'

const DeploymentTargetContext = createContext<
  Omit<DeploymentTargetProviderProps, 'children'>
>({
  deploymentTargetName: 'development',
})

export type DeploymentTargetProviderProps = {
  deploymentTargetName: string
  children: React.ReactNode
}

export function DeploymentTargetProvider({
  deploymentTargetName,
  children,
}: DeploymentTargetProviderProps) {
  return (
    <DeploymentTargetContext.Provider
      value={{
        deploymentTargetName,
      }}
    >
      {children}
    </DeploymentTargetContext.Provider>
  )
}

export const useDeploymentTargetContext = () =>
  useContext(DeploymentTargetContext)
